import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageFallback } from "@/components/store/Skeletons";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const target = location.pathname === "/login" ? "/profile" : location.pathname + location.search;
    api
      .post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        toast.success(`Welcome, ${data.name.split(" ")[0]}`);
        navigate(target, { replace: true });
      })
      .catch((e) => {
        setUser(false);
        toast.error(errMsg(e));
        navigate("/login", { replace: true });
      });
  }, [location, navigate, setUser]);

  return <PageFallback full />;
}
